<template>
    <div v-show="isAddNewAccountLicenseFailedModalVisible">
        <transition name="slide">
            <div :class="type == 2 ? 'modal-mask' : 'modal-mask1'">
                <div class="modal-dialog modal-dialog-slideout modal-lg" style="max-width: 100%;">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                          <div class="" style="width: 100%;">
                            <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                            <button type="button" class="close float-right" @click="hide">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="clearfix"></div>
                          </div>

                        </div>
                        <div class="modal-body">
                          <div class="row mb-4">
                            <div class="col-9 pl-3">
                              <div class="h3 d-inline mr-2 text-uppercase">Add Subscription</div>
                              
                            </div>
                          </div>                            
                            <div class="row">
                                <div class="col-12">
                                    <div class="successPanel">
                                        <div class="success_col_1">
                                            <p class="success-note">
                                                Your payment transaction has failed and the subscription is not purchased.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-md-center closebtn_div">
                                <div class="col-6">
                                    <button type="button" class="btn btn-sm btn-blue closeBtn text-center" @click="closeModal">Close Window</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: ['isAddNewAccountLicenseFailedModalVisible', 'landingPage', 'type'],
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        hide() {
            this.closeModal();
        },
        closeModal() {
            let routeData = this.$router.resolve({name: this.landingPage});
            window.open(routeData.href, '_self');
        },
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 80%; }
.maheading_3 { width: 20%; }
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.successPanel { 
    padding: 20px;
    border-radius: 10px;
}
.success-note { font-size: 1.05rem; text-align: center; margin: 2rem 0; color: #dc3545; font-weight: 900; }
.success_col_1 { width: 100%; text-align: center;}
.closebtn_div { margin: 8rem; }
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_account_license_failed_modal.vue